<template>
  <div v-if="!isDropdown && !isStayBundle" class="buybox__options">
    <template v-for="(option, optionIndex) in product.options" :key="optionIndex">
      <div v-if="!hideOption(option) && !isMultiPackOption(option) && (option.name !== 'Title') && !((isOneFlavor || isOneFlavorBuybox) && (option.name !== 'Flavor'))" class="buybox__option" 
        :class="'option-'+(option.name).toLowerCase().replace(/ /g, '-'), { 'hide': isOneFlavor && option.name !== 'Flavor' }">
        
        <div v-if="isStayBundle || isOneFlavor || isOneFlavorBuybox" class="option-group_label" :class="{ 'hide': product.bundleRelatedToggleProduct }">{{ option.name }}</div>

        <div v-else class="option-group_label">{{ option.name }}:</div>

        <div class="buybox__options-values">
          <template v-for="(value, index) in option.values" :key="index">
          
            <div v-if="isVariantOptionAvailable(optionIndex,value)" 
              :class="['option-chip', { 'selected': option.selected === value }, `${(option.name).toLowerCase().replace(/ /g, '-')}-${value.toLowerCase().replace(/ & /g, ' ').replace(/ /g, '-')}`]"
              :style="{ '--flavor': 'var(--color-' + value.toLowerCase().replace(/ & /g, ' ').replace(/ /g, '-') + ')' }"
              @click="handleOptionChange(option.name, value, optionIndex)">
              {{ option.name === 'Size'? formatSizeOption(value) : value }}
            </div>

          </template>
        </div>
      </div>
    </template>
  </div>
  <div v-else-if="!isStayBundle" class="buybox__options-drpdwn-wrapper">
    <template v-for="(option, optionIndex) in product.options" :key="optionIndex">
      <div v-if="!hideOption(option) && !isMultiPackOption(option)" class="buybox__option">
        <div class="option-group_label">{{ option.name }}:</div>
        <div :class="['buybox__options-drpdwn' , {'open': isOptionDropdownOpen}]" @click="toggleOptionDrpdwn">
          <div class="buybox__options-drpdwn-selected">{{ isOptionDropdownOpen ? 'Select Option' : option.values.find(value => option.selected === value )  }}</div>
          <div class="buybox__options-drpdwn-arrow"></div>
          <div class="buybox__options-drpdwn-values" v-if="isOptionDropdownOpen">
            <template v-for="(value, index) in option.values" :key="index">
              <div 
                v-if="isVariantOptionAvailable(optionIndex,value)"
                :class="['buybox__options-drpdwn-value', { 'selected': option.selected === value }]" 
                @click="handleOptionChange(option.name, value, optionIndex)"
              >
                {{ option.name === 'Size'? formatSizeOption(value) : value }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
  import { toRefs, ref } from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      required: true,
    },

    selectedVariant: {
      type: Object,
      default: null,
    },

    isDropdown: {
      type: Boolean,
      default: false
    },

    isStayBundle: {
      type: Boolean,
      default: false, 
    },

    isOneFlavor: {
      type: Boolean,
      default: false, 
    },

    isOneFlavorBuybox: {
      type: Boolean,
      default: false, 
    }
  });

  const { product, selectedVariant, isStayBundle } = toRefs(props);
  const emit = defineEmits(['update-option']);
  const isOptionDropdownOpen = ref(false)

  const hideOption = (option) => {
    const { options } = product.value;
    const flavorOption = options.find(opt => opt.name.toLowerCase() === 'flavor');
    const isUnflavoredOnly = flavorOption && flavorOption.values.length === 1 && flavorOption.values[0].toLowerCase() === 'unflavored';

    return option.name === 'Flavor' && isUnflavoredOnly;
  }

  const isMultiPackOption = (option) => {
    return ['boxes', 'tubs', 'bottles'].includes(option.name.toLowerCase());
  };

  const isVariantOptionAvailable = (index, value) => {
    const { options } = selectedVariant.value;
    const { variants } = product.value;

    const optionsMap = [...options];
    optionsMap[index] = value;

    return variants.some(variant =>
      !variant.disabled &&
      variant.options[0] === optionsMap[0] &&
      variant.options[1] === optionsMap[1] &&
      (index !== 2 || variant.options[2] === optionsMap[2])
    );
  };

  const handleOptionChange = (key, value, index) => {
    emit('update-option', key, value, index);
  };

  const toggleOptionDrpdwn = () => {
    isOptionDropdownOpen.value = !isOptionDropdownOpen.value;
  }

  const formatSizeOption = (value) => {
    if (value == 1) {
      return value += ' Serving';
    } else {
      return value += ' Servings';
    }
  }
</script>
